import { render, staticRenderFns } from "./ListTopSpenderCampaign.vue?vue&type=template&id=112b28a7&scoped=true"
import script from "./ListTopSpenderCampaign.vue?vue&type=script&lang=js"
export * from "./ListTopSpenderCampaign.vue?vue&type=script&lang=js"
import style0 from "./ListTopSpenderCampaign.vue?vue&type=style&index=0&id=112b28a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b28a7",
  null
  
)

export default component.exports